export const SimpleCard = ({
  text,
  subtext,
  growAnimate = false,
  onClick = () => {},
  className = "",
}: {
  text: string;
  subtext: string;
  growAnimate?: boolean;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        bg-light-green-bg rounded-lg border border-transparent
        w-full text-left px-[24px] pt-[24px] pb-[40px]
        ${growAnimate && "md:hover:scale-[1.02]"}
        ${"md:hover:cursor-pointer md:hover:border md:hover:border-pry-green-200"} ${className} transition-all duration-300`}
    >
      <p className="text-pry-green-200 font-medium text-[20px] pb-2">{text}</p>

      <p className="text-pry-dark-green-300/80 text-[14px]">{subtext}</p>
    </button>
  );
};
